(() => {
  const boot = () => {
  const root = document.querySelector('[data-lpq]');
  if (!root || root.dataset.ready) return null;
  root.dataset.ready = '1';
  const ac = new AbortController();
  const on = (type, fn) => document.addEventListener(type, fn, { signal: ac.signal });

  let CFG = {};
  try { CFG = JSON.parse(document.querySelector('[data-lpq-config]')?.textContent || '{}'); } catch (e) { CFG = {}; }
  const T = Object.assign({
    count: 'Question [n] of [total]', next: 'Continue', ready: 'Your match is ready', heading: "Here's what we'd pick for your [pets].",
    best: 'Best match', why: "Why it's right for your pet", alts: 'Alternative products', altsMulti: 'Something for everyone at home',
    alsoGreat: 'Also great', forPet: 'For your [pet]', add: 'Add to cart', addShort: 'Add', added: 'Added', view: 'View product',
    restart: 'Start again', shopAll: 'Shop all products', shopAllUrl: '/collections/all'
  }, Object.fromEntries(Object.entries(CFG.texts || {}).filter(([, v]) => v)));

  const PET_ICONS = {
    guinea: '<svg viewBox="0 0 48 48"><path d="M8 30c0-9 8-15 17-15 9 0 15 6 15 13 0 6-5 9-12 9H16c-5 0-8-3-8-7z"/><circle cx="33" cy="25" r="1.6" fill="currentColor" stroke="none"/><path d="M36 17c1-3 4-4 6-2M40 29h4M14 37v3M30 37v3"/></svg>',
    rabbit: '<svg viewBox="0 0 48 48"><path d="M19 20c-2-8-1-15 2-15s4 7 3 14M27 19c0-8 2-14 5-14s3 7 0 15"/><path d="M12 33c0-8 6-13 13-13s12 5 12 12c0 6-5 10-12 10s-13-3-13-9z"/><circle cx="21" cy="29" r="1.5" fill="currentColor" stroke="none"/><circle cx="29" cy="29" r="1.5" fill="currentColor" stroke="none"/><path d="M23 34l2 1.5 2-1.5"/></svg>',
    dog: '<svg viewBox="0 0 48 48"><path d="M14 14l-6 4 2 10 5-3M34 14l6 4-2 10-5-3"/><path d="M14 14c3-3 7-4 10-4s7 1 10 4c2 4 2 10 0 15-2 6-6 9-10 9s-8-3-10-9c-2-5-2-11 0-15z"/><circle cx="19" cy="23" r="1.5" fill="currentColor" stroke="none"/><circle cx="29" cy="23" r="1.5" fill="currentColor" stroke="none"/><path d="M21 31c1.5 1.5 4.5 1.5 6 0M24 28v3"/></svg>',
    cat: '<svg viewBox="0 0 48 48"><path d="M11 9l4 12M37 9l-4 12M11 9l9 7h8l9-7"/><path d="M11 21c0 10 6 17 13 17s13-7 13-17"/><circle cx="19" cy="26" r="1.5" fill="currentColor" stroke="none"/><circle cx="29" cy="26" r="1.5" fill="currentColor" stroke="none"/><path d="M22 31l2 1.5 2-1.5M7 29l8-1M7 34l8-3M41 29l-8-1M41 34l-8-3"/></svg>',
    other: '<svg viewBox="0 0 48 48"><circle cx="15" cy="20" r="3.5"/><circle cx="21" cy="12" r="3.5"/><circle cx="29" cy="12" r="3.5"/><circle cx="35" cy="20" r="3.5"/><path d="M24 40c-6 0-10-3-10-7s4-6 6-8.5c1-1.4 2.3-2.5 4-2.5s3 1.1 4 2.5c2 2.5 6 4.5 6 8.5s-4 7-10 7z"/></svg>'
  };
  const ICON = {
    bed: '<svg viewBox="0 0 24 24"><path d="M3 18v-7h18v7M3 14h18M6 11V8h5v3"/></svg>',
    drop: '<svg viewBox="0 0 24 24"><path d="M12 3c3 4 6 7 6 11a6 6 0 0 1-12 0c0-4 3-7 6-11z"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18"/></svg>',
    toy: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 4c-2 3-2 13 0 16M4.5 9.5c4 1.5 11 1.5 15 0"/></svg>',
    heart: '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>',
    help: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6V14M12 17v.5"/></svg>',
    clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    ruler: '<svg viewBox="0 0 24 24"><path d="M3 15l12-12 6 6-12 12zM7 11l2 2M10 8l2 2M13 5l2 2"/></svg>',
    cage: '<svg viewBox="0 0 24 24"><path d="M4 6h16v14H4zM8 6v14M12 6v14M16 6v14M4 4h16"/></svg>',
    grid: '<svg viewBox="0 0 24 24"><path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z"/></svg>',
    custom: '<svg viewBox="0 0 24 24"><path d="M4 20V8l8-4 8 4v12zM9 20v-6h6v6"/></svg>',
    floor: '<svg viewBox="0 0 24 24"><path d="M3 17l9-5 9 5-9 5zM3 12l9-5 9 5"/></svg>',
    layers: '<svg viewBox="0 0 24 24"><path d="M12 4l9 4.5-9 4.5-9-4.5z"/><path d="M3 12.5l9 4.5 9-4.5M3 16.5l9 4.5 9-4.5"/></svg>',
    shield: '<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5.5c0 4.4-3 7.8-7 9.5-4-1.7-7-5.1-7-9.5V6z"/></svg>',
    tag: '<svg viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8zM7.5 7.5h.01"/></svg>',
    box: '<svg viewBox="0 0 24 24"><path d="M3 7l9-4 9 4v10l-9 4-9-4zM3 7l9 4 9-4M12 11v10"/></svg>',
    one: '<svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12" rx="2"/></svg>',
    star: '<svg viewBox="0 0 24 24"><path d="M12 3l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.9 6.6 19.7l1.1-6.1L3.2 9.4l6.1-.8z"/></svg>',
    s: '<svg viewBox="0 0 24 24"><rect x="8" y="8" width="8" height="8"/></svg>',
    m: '<svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12"/></svg>',
    l: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18"/></svg>'
  };

  const list = (s) => String(s || '').split(',').map((x) => x.trim().toLowerCase()).filter(Boolean);
  const TAG_ICON = { cleaning: 'sparkle', waterproof: 'drop', base: 'layers', enrichment: 'toy', comfort: 'heart', unsure: 'help', time: 'clock', setup: 'cage', bedding: 'bed', midwest: 'cage', cc: 'grid', custom: 'custom', floor: 'floor', bed: 'bed', multi: 'box', cheap: 'tag', single: 'one', bundle: 'box', best: 'star' };
  const ICON_ALIAS = { house: 'custom', square: 'one', water: 'drop', clean: 'sparkle', ball: 'toy', question: 'help', price: 'tag', layer: 'layers', 'guinea-pig': 'guinea', paw: 'other', pet: 'other' };
  const SPECIAL = ['cheap', 'bundle', 'single', 'best', 'multi', 'unsure'];
  const CAGE = ['guinea', 'rabbit', 'other'];
  const PET_NAME = { guinea: 'guinea pig', rabbit: 'rabbit', dog: 'dog', cat: 'cat', other: 'pet' };

  const STEPS = (CFG.questions || []).map((q) => {
    const options = String(q.answers || '').split(/\r?\n/).map((line) => {
      const cut = line.indexOf('|');
      const label = (cut < 0 ? line : line.slice(0, cut)).trim();
      const tokens = cut < 0 ? [] : list(line.slice(cut + 1).replace(/\|/g, ','));
      const isIcon = (t) => /^icon\s*[:=]/.test(t);
      const named = (tokens.find(isIcon) || '').replace(/^icon\s*[:=]\s*/, '');
      const pick = ICON_ALIAS[named] || named;
      return { label, tags: tokens.filter((t) => !isIcon(t)), pick };
    }).filter((o) => o.label).map((o, i) => ({
      v: String(i), label: o.label, tags: o.tags, pet: !!q.pets, key: o.tags[0] || 'other',
      petIcon: PET_ICONS[o.pick] ? o.pick : null,
      icon: (ICON[o.pick] && o.pick) || o.tags.map((t) => TAG_ICON[t]).find(Boolean) || 'star'
    }));
    return { id: q.id, multi: !!q.pets, pets: !!q.pets, title: q.title || '', hint: q.hint || '', weight: Number(q.weight) || 0, cageOnly: !!q.cageOnly, skipTags: list(q.skipTags), options };
  }).filter((step) => step.options.length);

  const PROD = {};
  (CFG.products || []).forEach((p) => {
    if (!p || !p.handle || PROD[p.handle]) return;
    const why = {};
    const whyOrder = [];
    String(p.reasons || '').split(/\r?\n/).forEach((line) => {
      const cut = line.indexOf('|');
      if (cut < 0) return;
      const tag = line.slice(0, cut).trim().toLowerCase();
      const text = line.slice(cut + 1).trim();
      if (tag && text && !why[tag]) { why[tag] = text; whyOrder.push(tag); }
    });
    PROD[p.handle] = { ...p, pets: (p.pets || []).filter(Boolean), tags: list(p.tags), strong: list(p.strong), unfit: list(p.unfit), level: Number(p.level) || 1, variants: p.variants || [], why, whyOrder };
  });
  const ANY_AVAILABLE = Object.values(PROD).some((p) => p.available);

  const body = root.querySelector('[data-lpq-body]');
  const bar = root.querySelector('[data-lpq-bar]');
  const back = root.querySelector('[data-lpq-back]');
  const dialog = root.querySelector('[role="dialog"]');
  let answers = {};
  let history = [];
  let index = 0;
  let lastFocus = null;

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const chosen = (step) => {
    const a = answers[step.id];
    if (a == null) return [];
    const vs = Array.isArray(a) ? a : [a];
    return step.options.filter((o) => vs.includes(o.v));
  };
  const petsChosen = () => {
    const step = STEPS.find((x) => x.pets);
    return step ? chosen(step).map((o) => o.key) : [];
  };
  const tagsBefore = (i) => STEPS.slice(0, i).filter((x) => !x.pets).flatMap((x) => chosen(x).flatMap((o) => o.tags));
  const isSkipped = (step, i) => (step.cageOnly && !petsChosen().some((p) => CAGE.includes(p))) || (step.skipTags.length > 0 && tagsBefore(i).some((t) => step.skipTags.includes(t)));
  const visibleSteps = () => STEPS.filter((step, i) => !isSkipped(step, i));
  const answered = () => visibleSteps().filter((x) => !x.pets);
  const answeredTags = () => answered().flatMap((x) => chosen(x).flatMap((o) => o.tags));

  const needsFromAnswers = () => {
    const w = {};
    answered().forEach((x) => chosen(x).forEach((o) => o.tags.forEach((t) => { if (!SPECIAL.includes(t) && x.weight) w[t] = (w[t] || 0) + x.weight; })));
    return w;
  };

  const score = (handle, pets) => {
    const p = PROD[handle];
    if (!p || (!p.available && ANY_AVAILABLE)) return -1;
    const petHits = pets.filter((x) => p.pets.includes(x)).length;
    const w = needsFromAnswers();
    const tags = answeredTags();
    let s = 100 + petHits * 2;
    if (!petHits) s -= 30;
    if (!p.available) s -= 40;
    let needHit = 0;
    for (const [n, v] of Object.entries(w)) if (p.tags.includes(n) || p.strong.includes(n)) { s += v; needHit += v; }
    if (Object.keys(w).length && !needHit) s -= 4;
    if (p.strong.some((t) => tags.includes(t))) s += 10;
    if (p.unfit.some((t) => tags.includes(t))) s -= 6;
    if (tags.includes('cheap')) s += (3 - p.level) * 1.5;
    if (tags.includes('bundle') && p.kind !== 'single') s += 3;
    if (tags.includes('single') && p.kind === 'single') s += 2;
    if (tags.includes('best') && (p.kind === 'bundle' || p.featured)) s += 2;
    if (tags.includes('multi') && p.kind !== 'single') s += 2;
    if (p.pets[0] === pets[0]) s += 0.5;
    return s;
  };

  const rank = (pets, exclude = []) => Object.keys(PROD)
    .filter((h) => !exclude.includes(h))
    .map((h) => [h, score(h, pets)])
    .filter(([, s]) => s >= 0)
    .sort((a, b) => b[1] - a[1])
    .map(([h]) => h);

  const cageType = () => {
    let cage = null;
    answeredTags().forEach((t) => { if (t === 'midwest' || t === 'cc') cage = t; });
    return cage;
  };

  const reasons = (handle, pets) => {
    const p = PROD[handle];
    const out = [];
    const w = needsFromAnswers();
    const tags = answeredTags();
    Object.keys(w).sort((a, b) => w[b] - w[a]).forEach((n) => { if (p.why[n] && !out.includes(p.why[n])) out.push(p.why[n]); });
    p.whyOrder.forEach((n) => { if (out.length < 2 && !out.includes(p.why[n]) && (!p.strong.includes(n) || w[n])) out.push(p.why[n]); });
    const forPets = pets.filter((x) => p.pets.includes(x)).map((x) => PET_NAME[x]);
    if (forPets.length) out.push(`Made for your ${[...new Set(forPets)].join(' and ')}`);
    const cage = cageType();
    if (cage === 'midwest' && p.tags.includes('midwest')) out.push('Sized for a Midwest cage');
    if (cage === 'cc' && p.tags.includes('cc')) out.push('Fits a C&C 2x4 cage');
    if (tags.includes('multi') && p.kind !== 'single') out.push('Enough pieces to cover more than one cage');
    if (tags.includes('bundle') && p.kind !== 'single') out.push('A complete set, so nothing else to buy');
    if (tags.includes('cheap') && p.level === 1) out.push('One of our most affordable picks');
    return out.slice(0, 4);
  };

  const pickVariant = (handle) => {
    const vs = (PROD[handle]?.variants || []).filter((v) => v.available);
    if (!vs.length) return null;
    const cage = cageType();
    if (cage === 'cc') return vs.find((v) => /c&c|2x4/i.test(v.title)) || vs[0];
    if (cage === 'midwest') return vs.find((v) => /midwest/i.test(v.title)) || vs[0];
    return vs[0];
  };

  const setProgress = () => {
    const steps = visibleSteps();
    const done = index >= steps.length ? 1 : index / steps.length;
    bar.style.width = `${Math.max(4, Math.round(done * 100))}%`;
    back.hidden = index === 0 || index > steps.length;
  };

  const transition = (html, dir = 1) => {
    body.classList.remove('is-in-fwd', 'is-in-back');
    body.innerHTML = html;
    void body.offsetWidth;
    body.classList.add(dir > 0 ? 'is-in-fwd' : 'is-in-back');
    const first = body.querySelector('[data-lpq-focus]') || body.querySelector('button, a, select');
    first?.focus({ preventScroll: true });
  };

  const renderStep = (dir = 1) => {
    const steps = visibleSteps();
    if (index >= steps.length) return renderResult();
    const step = steps[index];
    const current = answers[step.id];
    const opts = step.options.map((o) => {
      const on = step.multi ? (current || []).includes(o.v) : current === o.v;
      const icon = o.pet ? PET_ICONS[o.petIcon || o.key] || PET_ICONS.other : ICON[o.icon] || '';
      return `<button type="button" class="lpq__opt${o.pet ? ' lpq__opt--pet' : ''}${on ? ' is-on' : ''}" data-lpq-opt="${o.v}" aria-pressed="${on}">
        <span class="lpq__ico" aria-hidden="true">${icon}</span><span class="lpq__lbl">${esc(o.label)}</span>
        <span class="lpq__tick" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span></button>`;
    }).join('');
    transition(`<div class="lpq__step">
      <p class="lpq__count">${esc(T.count.replace('[n]', index + 1).replace('[total]', index === 0 ? STEPS.length : steps.length))}</p>
      <h2 class="lpq__q" id="LpqTitle" tabindex="-1" data-lpq-focus>${esc(step.title)}</h2>
      ${step.hint ? `<p class="lpq__hint">${esc(step.hint)}</p>` : ''}
      <div class="lpq__opts${step.multi ? ' lpq__opts--pets' : ''}">${opts}</div>
      ${step.multi ? `<button type="button" class="lpq__next" data-lpq-next ${current && current.length ? '' : 'disabled'}>${esc(T.next)}</button>` : ''}
    </div>`, dir);
    setProgress();
  };

  const productCard = (handle, role, pets) => {
    const p = PROD[handle];
    const d = p;
    const v = pickVariant(handle);
    const multi = (d.variants || []).filter((x) => x.available).length > 1;
    const select = multi ? `<select class="lpq__sel" data-lpq-variant aria-label="Choose an option for ${esc(p.name)}">${d.variants.filter((x) => x.available).map((x) => `<option value="${x.id}"${v && x.id === v.id ? ' selected' : ''}>${esc(x.title)}</option>`).join('')}</select>` : `<input type="hidden" data-lpq-variant value="${v ? v.id : ''}">`;
    const img = d.img ? `<img src="${d.img}" alt="${esc(p.name)}" loading="lazy">` : '';
    const add = (cls, label) => (v ? `<button type="button" class="${cls}" data-lpq-add>${label}</button>` : `<a class="${cls}" href="${d.url}">${esc(T.view)}</a>`);
    if (role === 'best') {
      const why = reasons(handle, pets).map((r) => `<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>${esc(r)}</li>`).join('');
      return `<article class="lpq__best">
        <a class="lpq__best-img" href="${d.url}">${img}</a>
        <div class="lpq__best-body">
          <p class="lpq__badge"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.7 5.6 6.1.8-4.5 4.2 1.1 6.1L12 16.9 6.6 19.7l1.1-6.1L3.2 9.4l6.1-.8z"/></svg>${esc(T.best)}</p>
          <h3>${esc(p.name)}</h3>
          <p class="lpq__price">${d.compare ? `<del>${d.compare}</del>` : ''}${d.price}</p>
          <p class="lpq__why-title">${esc(T.why)}</p>
          <ul class="lpq__why">${why}</ul>
          <div class="lpq__buy">${v ? select : ''}${add('lp-btn lpq__add', esc(T.add))}</div>
          ${v ? `<a class="lpq__link" href="${d.url}">${esc(T.view)}</a>` : ''}
        </div>
      </article>`;
    }
    return `<article class="lpq__alt">
      <a class="lpq__alt-img" href="${d.url}">${img}</a>
      <div class="lpq__alt-body">
        ${role ? `<p class="lpq__alt-role">${esc(role)}</p>` : ''}
        <a class="lpq__alt-name" href="${d.url}">${esc(p.name)}</a>
        <p class="lpq__price lpq__price--sm">${d.compare ? `<del>${d.compare}</del>` : ''}${d.price}</p>
        <div class="lpq__buy lpq__buy--sm">${v ? select : ''}${add('lpq__add-sm', esc(T.addShort))}</div>
      </div>
    </article>`;
  };

  const renderResult = () => {
    const chosenPets = petsChosen();
    const pets = chosenPets.length ? chosenPets : ['other'];
    const ranked = rank(pets);
    const best = ranked[0];
    if (!best) {
      transition(`<div class="lpq__result"><p class="lpq__count">${esc(T.ready)}</p><div class="lpq__end"><a class="lp-btn" href="${esc(T.shopAllUrl)}">${esc(T.shopAll)}</a></div></div>`);
      bar.style.width = '100%';
      back.hidden = false;
      return;
    }
    const used = [best];
    const extras = [];
    pets.forEach((pet) => {
      if (PROD[best].pets.includes(pet) || extras.some((e) => PROD[e.handle].pets.includes(pet))) return;
      const pick = rank([pet], used).find((h) => PROD[h].pets.includes(pet));
      if (pick) { extras.push({ handle: pick, pet }); used.push(pick); }
    });
    const alts = ranked.filter((h) => !used.includes(h)).slice(0, Math.max(0, 2 - extras.length));
    const petList = [...new Set(pets.map((p) => PET_NAME[p]))];
    const others = [
      ...extras.map((e) => productCard(e.handle, T.forPet.replace('[pet]', PET_NAME[e.pet]), pets)),
      ...alts.map((h) => productCard(h, T.alsoGreat, pets))
    ].join('');
    transition(`<div class="lpq__result">
      <p class="lpq__count">${esc(T.ready)}</p>
      <h2 class="lpq__q" id="LpqTitle" tabindex="-1" data-lpq-focus>${esc(T.heading.replace('[pets]', petList.join(' & ')))}</h2>
      ${productCard(best, 'best', pets)}
      ${others ? `<p class="lpq__alts-title">${esc(extras.length ? T.altsMulti : T.alts)}</p><div class="lpq__alts">${others}</div>` : ''}
      <div class="lpq__end"><button type="button" class="lpq__restart" data-lpq-restart>${esc(T.restart)}</button><a href="${esc(T.shopAllUrl)}">${esc(T.shopAll)}</a></div>
    </div>`);
    bar.style.width = '100%';
    back.hidden = false;
  };

  const open = (event) => {
    event?.preventDefault();
    lastFocus = document.activeElement;
    answers = {};
    history = [];
    index = 0;
    root.hidden = false;
    document.documentElement.classList.add('lpq-lock');
    requestAnimationFrame(() => root.classList.add('is-open'));
    renderStep();
  };
  const close = () => {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('lpq-lock');
    setTimeout(() => { root.hidden = true; }, 250);
    lastFocus?.focus?.();
  };

  const addToCart = async (btn) => {
    const wrap = btn.closest('.lpq__buy');
    const id = Number(wrap.querySelector('[data-lpq-variant]').value);
    if (!id) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    const drawer = document.querySelector('cart-drawer');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: drawer ? ['cart-drawer', 'cart-icon-bubble'] : [], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not add to cart');
      btn.textContent = T.added;
      btn.classList.add('is-added');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        setTimeout(() => {
          close();
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id, sections: data.sections });
        }, 500);
      } else {
        setTimeout(() => { window.location.href = '/cart'; }, 500);
      }
    } catch (e) {
      btn.textContent = 'Try again';
      btn.disabled = false;
    } finally {
      btn.classList.remove('is-loading');
      setTimeout(() => { if (btn.isConnected && btn.textContent !== label) { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; } }, 2200);
    }
  };

  on('click', (event) => {
    const opener = event.target.closest('[data-lpq-open], a[href="#quiz"], a[href$="#find-my-match"]');
    if (opener) { open(event); return; }
    if (!root.classList.contains('is-open')) return;
    if (event.target.closest('[data-lpq-close]')) { close(); return; }
    if (event.target.closest('[data-lpq-back]')) {
      const steps = visibleSteps();
      if (index > steps.length) index = steps.length;
      index = Math.max(0, (history.pop() ?? index - 1));
      renderStep(-1);
      return;
    }
    if (event.target.closest('[data-lpq-restart]')) { answers = {}; history = []; index = 0; renderStep(-1); return; }
    const add = event.target.closest('[data-lpq-add]');
    if (add) { addToCart(add); return; }
    const opt = event.target.closest('[data-lpq-opt]');
    if (opt) {
      const step = visibleSteps()[index];
      if (step.multi) {
        const list = new Set(answers[step.id] || []);
        list.has(opt.dataset.lpqOpt) ? list.delete(opt.dataset.lpqOpt) : list.add(opt.dataset.lpqOpt);
        answers[step.id] = [...list];
        opt.classList.toggle('is-on');
        opt.setAttribute('aria-pressed', String(list.has(opt.dataset.lpqOpt)));
        body.querySelector('[data-lpq-next]').disabled = list.size === 0;
        return;
      }
      answers[step.id] = opt.dataset.lpqOpt;
      body.querySelectorAll('[data-lpq-opt]').forEach((b) => { b.classList.toggle('is-on', b === opt); b.setAttribute('aria-pressed', String(b === opt)); });
      history.push(index);
      setTimeout(() => { index += 1; renderStep(1); }, 260);
      return;
    }
    if (event.target.closest('[data-lpq-next]')) { history.push(index); index += 1; renderStep(1); }
  });

  on('keydown', (event) => {
    if (!root.classList.contains('is-open')) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    const f = [...dialog.querySelectorAll('button:not([disabled]):not([hidden]), a[href], select, [tabindex="0"]')].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    if (event.shiftKey && document.activeElement === f[0]) { event.preventDefault(); f[f.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === f[f.length - 1]) { event.preventDefault(); f[0].focus(); }
  });

  if (location.hash === '#quiz') open();
  return ac;
  };
  let current = boot();
  document.addEventListener('shopify:section:load', () => {
    const fresh = document.querySelector('[data-lpq]');
    if (!fresh || fresh.dataset.ready) return;
    current?.abort();
    document.documentElement.classList.remove('lpq-lock');
    current = boot();
  });
})();
